<div class="col-sm-12">
    <label class="col-sm-12">{{ label }}</label>    
    <p class="col-sm-12">{{ getValue() }}</p>
</div>